const getProviderValue = (provider: string | { value: string }) => {
  if (provider && typeof provider === 'string') return provider;
  if (typeof provider === 'object' && provider.value) return provider.value;
  return '';
};

export default getProviderValue;
